/**
 * The client allocation gate (owner, Oct 16 2026; docs/CLIENT_ALLOCATION.md): in a firm that allocates,
 * a client never reaches a paraplanner until allocation passes them on. From the onboarding start
 * (`pending`) until allocated or skipped (`waiting` until then), paraplanners neither list nor open
 * them; everyone else sees them as usual. Released clients (`paraplanner`, `guided`) and every client
 * of a firm on Off are visible as before.
 *
 * Para trial (owner, Nov 2 2026): a client picked for the trial (`mode: 'trial'`) stays hidden from
 * paraplanners while `guided` too, so they never meet the client. Sent back, or at their first annual
 * review, the status becomes `paraplanner` and they're visible again.
 *
 * Status lives in clients/{id}.assignment.allocation.status (server-written,
 * server/lib/clientAllocation/allocation.cjs); the slim list rows carry the whole `assignment` map.
 *
 * CommonJS-bodied on purpose: the browser bundle and the server both require it.
 */
var HELD_FROM_PARAPLANNERS = ['pending', 'waiting'];

var PARA_TRIAL_MODE = 'trial';
var PARA_TRIAL_STATUSES = ['pending', 'waiting', 'guided'];

/** Whether this client is on the Para trial now: picked, and not sent back to the paraplanners. */
function isParaTrialClient(clientData) {
  var allocation = clientData && clientData.assignment && clientData.assignment.allocation;
  return Boolean(allocation && allocation.mode === PARA_TRIAL_MODE && PARA_TRIAL_STATUSES.indexOf(allocation.status) !== -1);
}

function isHeldFromParaplanners(clientData) {
  var allocation = clientData && clientData.assignment && clientData.assignment.allocation;
  return Boolean(allocation && HELD_FROM_PARAPLANNERS.indexOf(allocation.status) !== -1) || isParaTrialClient(clientData);
}

module.exports = {
  HELD_FROM_PARAPLANNERS: HELD_FROM_PARAPLANNERS,
  PARA_TRIAL_MODE: PARA_TRIAL_MODE,
  isParaTrialClient: isParaTrialClient,
  isHeldFromParaplanners: isHeldFromParaplanners,
};
